import { call, put } from 'redux-saga/effects';
import axios from '../../../utils/axios';
import {
  getVendors,
  getdeigantionlist,
  getRoleslist,
  startLoading,
  getVendorByid,
  getVendorOrder,
  getVendorCompetitorStock,
  getChildvendore,
  getUnassignvendor,
  getAssigneduser,
  deleteVendor,
  getTerritoryList,
  getOwnStock,
  addNewVendor,
  updateVendor,
  setTotalVendors,
} from '../../slices/vendors';
import { GettingRoleID } from '../../../components/GettingRoleID';
import {
  getErrorMessage,
  hasError,
  setResponse,
  startFormLoading,
  stopFormLoading,
  startAssignmentLoader,
  stopAssignmentLoader,
  getDeleteMessage,
  getSuccessMessage,
  setBulkResponse,
} from '../../slices/responseStatus';
import { BASEURL } from '../../../BaseUrl/BaseUrl';
import { isLogout } from '../../slices/login';

export function* vendorsListSaga(state) {
  try {
    const { designationId, page = 1, limit = 20, search } = state;
    yield put(startLoading(true));
    yield put(startFormLoading());
    yield put(hasError(false));
    const id = GettingRoleID('vendor');
    const url = `${BASEURL}/users/?role=${id}${
      designationId ? `&designation=${designationId}` : ''
    }&page=${page}&limit=${limit}${search ? `&searchText=${search}` : ''}`;
    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.get(url, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    const userData = response?.data?.data?.users?.user;
    const total = response?.data?.data?.users?.totalRowsValue;
    if (userData === undefined) {
      yield put(getVendors([]));
    } else {
      yield put(getVendors(userData));
      yield put(setTotalVendors(total));
    }
    yield put(stopFormLoading());
  } catch (error) {
    yield put(hasError(true));
    yield put(startLoading(false));
    yield put(getVendors([]));
    yield put(getErrorMessage(error.error.message));
    if (error.error?.statusCode === 401) {
      yield put(isLogout(true));
    }
  }
}

export function* DeleteVendorRowSaga(state) {
  try {
    yield put(startLoading(true));
    yield put(hasError(false));
    const { id } = state;

    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.delete(`${BASEURL}/users/${id}`, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    if (response.status === 200) {
      yield put(deleteVendor(id));
    }

    // yield call(vendorsListSaga);
    yield put(startLoading(false));
    yield put(getDeleteMessage(response.data.meta.message));
  } catch (error) {
    yield put(startLoading(false));
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
  }
}

export function* addVendorSaga(state) {
  try {
    yield put(hasError(false));
    yield put(startFormLoading());
    const { item } = state;

    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.post(`${BASEURL}/users`, item, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    if (response.status === 200) {
      const addNewVendorData = {
        id: response.data.data.id,
        ...item,
      };
      yield put(addNewVendor(addNewVendorData));
    }
    yield put(getSuccessMessage(response.data.meta.message));
    yield put(setResponse(response.status));
  } catch (error) {
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
  }
}

export function* editVendorSaga(state) {
  try {
    yield put(hasError(false));

    const { index, item, statusChange } = state;
    if (statusChange !== 'statusChange') {
      yield put(startFormLoading());
    }

    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.put(`${BASEURL}/users/${index}`, item, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    yield put(updateVendor(item));
    if (statusChange !== 'statusChange') {
      yield put(setResponse(response.status));
    }
  } catch (error) {
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
  }
}

export function* getdesignation() {
  try {
    yield put(hasError(false));
    yield put(startFormLoading());
    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.get(`${BASEURL}/designations/?dept=vendor`, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    const designationData = response.data.data.Designations.designation;
    yield put(getdeigantionlist(designationData === undefined ? [] : designationData));
    yield put(stopFormLoading());
  } catch (error) {
    yield put(hasError(true));
    yield put(stopFormLoading());
    yield put(startLoading(false));
    yield put(getErrorMessage(error?.error?.message));
  }
}

export function* getTerritory() {
  try {
    yield put(hasError(false));
    yield put(startFormLoading());
    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.get(`${BASEURL}/territorymaster`, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    const territories = response?.data?.data?.territoryMaster?.data;
    yield put(getTerritoryList(territories === undefined ? [] : territories));
    yield put(stopFormLoading());
  } catch (error) {
    yield put(hasError(true));
    yield put(stopFormLoading());
    yield put(startLoading(false));
    yield put(getErrorMessage(error.error.message));
  }
}

export function* getRoles() {
  try {
    yield put(hasError(false));
    yield put(startFormLoading());
    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.get(`${BASEURL}/roles`, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    const { Roles } = response.data.data;
    if (Roles) {
      window.localStorage.setItem('roles', JSON.stringify(Roles));
    } else {
      window.localStorage.setItem('roles', JSON.stringify([]));
    }
    yield put(getRoleslist(Roles));
    // yield call(employeeListSaga);
    yield put(stopFormLoading());
  } catch (error) {
    yield put(hasError(true));
    yield put(startLoading(false));
    yield put(stopFormLoading());
    yield put(getErrorMessage(error.error.message));
  }
}

export function* gerVendorDetail(state) {
  try {
    const { id, model, startDate, endDate } = state;
    yield put(hasError(false));
    yield put(startFormLoading());
    const Token = window.localStorage.getItem('auth-token');
    if (model === 'Detail') {
      const getUserByID = yield axios.get(`${BASEURL}/users/${id}`, {
        headers: {
          'x-auth-token': `${Token}`,
        },
      });
      const { user } = getUserByID.data.data;
      yield put(getVendorByid(user[0]));
    }
    if (model === 'Orders') {
      const response = yield axios.get(
        // kunal told to change the url on 06-07-2023
        `${BASEURL}/userActivities/user/vendor/${id}?startDate=${
          startDate || new Date().toISOString().substr(0, 10)
        }&endDate=${endDate || new Date().toISOString().substr(0, 10)}`,
        {
          headers: {
            'x-auth-token': `${Token}`,
          },
        }
      );
      const { UserActivities } = response.data.data;
      yield put(getVendorOrder(UserActivities === undefined ? [] : UserActivities));
    }
    if (model === 'Competitor Stock') {
      const response = yield axios.get(`${BASEURL}/userActivities/user/vendor/competitorstock/${id}`, {
        headers: {
          'x-auth-token': `${Token}`,
        },
      });
      const { UserActivities } = response.data.data;
      yield put(getVendorCompetitorStock(UserActivities === undefined ? [] : UserActivities));
    }
    if (model === 'Own Stock') {
      const response = yield axios.get(`${BASEURL}/userActivities/user/vendor/ownstock/${id}`, {
        headers: {
          'x-auth-token': `${Token}`,
        },
      });
      const { UserActivities } = response.data.data;

      yield put(getOwnStock(UserActivities === undefined ? [] : UserActivities));
    }

    yield put(stopFormLoading());
  } catch (error) {
    yield put(hasError(true));

    yield put(getErrorMessage(error.error.message));
  }
}

export function* vendorBulkUpload(state) {
  try {
    yield put(startLoading(true));
    yield put(hasError(false));
    const { item } = state;
    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.post(`${BASEURL}/users/upload`, item, {
      headers: {
        'x-auth-token': `${Token}`,
        'content-type': 'multipart/form-data',
      },
    });
    yield put(startLoading(false));
    if (response.status === 200) {
      yield put(getSuccessMessage(response.data.meta.message));
      yield put(setBulkResponse(response.status));
    }
  } catch (error) {
    yield put(startLoading(false));
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
  }
}

export function* vendorHierarchy(state) {
  try {
    const { DesignationID } = state;
    yield put(hasError(false));
    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.get(`${BASEURL}/hierarchies/designation/${DesignationID}?dept=vendor`, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });

    const { designations } = response.data.data;

    yield put(getChildvendore(designations[0]));
    // yield call(vendorsListSaga);
  } catch (error) {
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
  }
}

export function* assignunassignevendore(state) {
  try {
    yield put(startAssignmentLoader());
    const { childDesignationID, currentUserID, searchText: st, character: ch } = state;
    const searchText = st ?? '';
    const character = ch ?? '';
    yield put(hasError(false));
    const Token = window.localStorage.getItem('auth-token');
    if (currentUserID && (currentUserID !== undefined || null)) {
      const getUnassignuser = yield axios.get(
        `${BASEURL}/userManagement/unassigned/by-role/?child_designation_id=${childDesignationID}&user_id=${currentUserID}&role=vendor&character=${character}&searchText=${searchText}`,
        {
          headers: {
            'x-auth-token': `${Token}`,
          },
        }
      );
      const data = getUnassignuser.data.data.Unassigned_users;
      yield put(getUnassignvendor(data === undefined ? [] : data));
      yield put(stopAssignmentLoader());
    } else {
      const getUnassignuser = yield axios.get(
        `${BASEURL}/userManagement/unassigned/by-role/?child_designation_id=${childDesignationID}&role=vendor&character=${character}`,
        {
          headers: {
            'x-auth-token': `${Token}`,
          },
        }
      );
      const data = getUnassignuser.data.data.Unassigned_users;
      yield put(getUnassignvendor(data === undefined ? [] : data));
      yield put(stopAssignmentLoader());
    }
    if (currentUserID !== undefined || null) {
      const getAssignuser = yield axios.get(
        `${BASEURL}/userManagement/vendors/${currentUserID}?designation_id=${childDesignationID}&role=vendor`,
        {
          headers: {
            'x-auth-token': `${Token}`,
          },
        }
      );
      const assigneduser = getAssignuser.data.data.Vendors;
      yield put(getAssigneduser(assigneduser === undefined ? [] : assigneduser));
    }

    yield put(stopAssignmentLoader());
  } catch (error) {
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
  }
}
